import { render, staticRenderFns } from "./UnknownOrigin.vue?vue&type=template&id=78fa310d"
import script from "./UnknownOrigin.vue?vue&type=script&lang=js"
export * from "./UnknownOrigin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports